import React from 'react'
import PropTypes from 'prop-types'

import ShowMore from '../../showMore/showMore'
import Tags from '../tags'

import styles from './checkoutForm.module.css'

const EmptyCheckoutForm = ({ item, children }) => {
  return (
    <div className={styles.checkoutContainer}>
      <div className={styles.itemMetaContainer}>
        <div className={styles.itemMeta}>
          <p>
            <a href={item.url} className={styles.itemName}>
              {item.name}
            </a>
          </p>
          <p className={styles.itemAuthor}>
            <em>by </em>
            <a className={styles.itemAuthorLink} href={item.author_url}>
              {item.author_username}
            </a>
          </p>
        </div>
      </div>
      <div className={styles.licensePlaceholder}>{children}</div>
      <div className={styles.buttonsPlaceholder} />
      <ShowMore
        linkClassName={styles.showMoreLink}
        linkExpandedClassName={styles.showMoreExpandedLink}
        showMoreLabel="See all tags"
        showLessLabel="See less tags"
      >
        <Tags tags={item.tags} />
      </ShowMore>
    </div>
  )
}

EmptyCheckoutForm.propTypes = {
  item: PropTypes.object.isRequired
}

export default EmptyCheckoutForm
